import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import { getAvailabilityManagementUrl } from '../../urls/inbox-urls';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import { ROUTING_SOURCE } from '../../shared/constants/routing-source';
import { HELPDESK } from '../../shared/constants/workspaces';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getAssignmentTooltip = ({
  disabled,
  isUngatedForHelpDeskRoutingScopeFiltering,
  routingSource,
  workSpace
}) => {
  const isHelpDesk = routingSource === ROUTING_SOURCE.HELP_DESK || workSpace === HELPDESK;
  if (isHelpDesk && isUngatedForHelpDeskRoutingScopeFiltering && disabled) {
    return null;
  }
  const commonProps = {
    elements: {
      Link
    },
    options: {
      external: true,
      href: isUngatedForHelpDeskRoutingScopeFiltering ? getUsersSeatsUrl() : getAvailabilityManagementUrl()
    }
  };
  if (isHelpDesk) {
    return isUngatedForHelpDeskRoutingScopeFiltering ? /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
      message: "routing-ui.routingRules.assignment.seats.ticketsTooltip_jsx"
    }, commonProps)) : /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
      message: "routing-ui.routingRules.assignment.seats.tickets_jsx"
    }, commonProps));
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
    message: "routing-ui.routingRules.assignment.seats.generic_jsx"
  }, commonProps));
};
const getAssignmentLabel = (routingSource, workSpace) => routingSource === ROUTING_SOURCE.HELP_DESK || workSpace === HELPDESK ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "routing-ui.routingRules.assignment.label.tickets"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "routing-ui.routingRules.assignment.label.generic"
});
export const RoutingTypeLabel = ({
  disabled,
  isUngatedForHelpDeskRoutingScopeFiltering,
  routingSource,
  workSpace
}) => {
  const label = getAssignmentLabel(routingSource, workSpace);
  const tooltip = getAssignmentTooltip({
    disabled,
    isUngatedForHelpDeskRoutingScopeFiltering,
    routingSource,
    workSpace
  });
  if (tooltip) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [label, /*#__PURE__*/_jsx(HelpIcon, {
        alignWithText: true,
        marginInlineStart: "100",
        title: tooltip
      })]
    });
  }
  return label;
};
RoutingTypeLabel.displayName = 'RoutingTypeLabel';